import Vue from 'vue'
import Router from 'vue-router'
import routes from './routes'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

Vue.use(Router)

const router = new Router({
  base: process.env.BASE_URL,
  mode: 'history',
  linkActiveClass: 'active',
  routes: routes
})

// router guards
router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const resetPasswordPages = ['PasswordReset', 'ForgotPassword']
  const authRequired = to.path !== '/login'
  const loggedIn = localStorage.getItem('user-token') // TODO: dont access directly to localstorage

  if (resetPasswordPages.includes(to.name) && !loggedIn) {
    return next()
  }

  if (authRequired && !loggedIn) {
    return next('/login')
  }

  if (loggedIn && to.path === '/') {
    return next({ name: 'orders' })
  }

  next()
})

router.beforeEach((to, from, next) => {
  NProgress.start()
  next()
})

router.afterEach(() => {
  // ...
  NProgress.done()
})

export default router
